const ajaxMainThemeUrlPrefix = document.location.origin + '/wp-content/themes/odds-scanner-main/ajax/';
const ajaxChildThemeUrlPrefix = document.location.origin + '/wp-content/themes/os-betting-child/ajax/';

// Onload
function onLoad() {  
    setCowntdown();
    smoothHref(); 

    //dropCookie();
    //bannerManager();

    trackContentScroll();
    trackSportsbookCardScroll();
    addSidebarContentNavigationHeight();

    trackLazyLoading();

    // Escape Listeners
    // notRecommendedPopUpEscape(); 
    // megaMenuEscape();
    // searchModalEscape();

    menuStates();
    
    //darkligthStates();

    if(search_archive) searchArchiveLayoutOnLoad();
};



/// DARK LIGH COOKIE
function setCookieDarkMode(name, value, days) {
        
    const date = new Date();
    date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000)); // Converte dias em milissegundos
    const expires = "expires=" + date.toUTCString();
    
    document.cookie = `${name}=${value}; ${expires}; path=/`;
}

function darkligthStates(state){        
    jQuery('html').attr('data-theme', state);
    //jQuery('.language-menu').addClass('closed');
    jQuery('.theme div').removeClass('active');
    jQuery('.'+state).addClass('active'); 
    
    setCookieDarkMode('data-theme', state, 400); 
    setCookieDarkMode('data-state', '', 400);

    jQuery('header .language .icon').toggleClass('active');
    if(jQuery('body').hasClass('widget-template-template')){
        location.reload();
    }

}
//CHECK PREFERENCES
function isDarkMode() {
    return window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches;
}
// Function to update the theme based on the user's preference
function updateTheme() {
    if (isDarkMode()) {
        jQuery('html').attr('data-theme', 'dark');
        setCookieDarkMode('data-theme', 'dark', 400);
        setCookieDarkMode('data-state', 'auto', 400);
    } else {
        jQuery('html').attr('data-theme', 'light');
        setCookieDarkMode('data-theme', 'light', 400);
        setCookieDarkMode('data-state', 'auto', 400);
    }
    jQuery('.language-menu').addClass('closed');
    jQuery('.theme div').removeClass('active');
    
}

// Listen for changes in the color scheme preference
//window.matchMedia('(prefers-color-scheme: dark)').addEventListener('change', updateTheme);


// Lazy Loading
function trackLazyLoading() {
    const lazyImages = jQuery('.lazy-loaded');

    let lazyImageObserver = new IntersectionObserver(function (entries, observer) {
        entries.forEach(function (entry) {
            if (entry.isIntersecting) {
                let lazyImage = entry.target;
                if (lazyImage.tagName == 'DIV') lazyImage.style.backgroundImage = 'url("' + lazyImage.dataset.src + '")';
                else lazyImage.src = lazyImage.dataset.src;
                lazyImage.classList.remove("lazy-loaded");
                lazyImageObserver.unobserve(lazyImage);
            }
        });
    });

    lazyImages.each(function () {
        lazyImageObserver.observe(this);
    });
}


// MENUS STATES
function menuStates(){    
    
    jQuery(".header-menu li.current-item .menu-item a").on('mouseover', function(event) {
        if(!jQuery(".header-menu li.current-item").hasClass('open')){
            jQuery(".header-menu li.current-item").toggleClass('open');
        }
        if(!jQuery(".language-menu").hasClass('closed')){
            jQuery(".language-menu").addClass('closed');
        }
        
        
        
    });
    // jQuery(".header-menu li.current-item .menu-item a").on('click', function(event) {
        
    //     jQuery(".header-menu li.current-item").toggleClass('open');
        
    // });
    jQuery(".header-menu .label-back").on('click', function(event) {
        
        jQuery("li.submenu").removeClass('opened');
        
    });
    jQuery("main").on('mouseover', function(event) {
        jQuery("li.submenu").removeClass('opened');
        jQuery(".header-menu li.current-item").removeClass('open');
    });
    
}

function activeLang(){
    jQuery('.lang-btn').addClass('active');
    jQuery('.container.lang').removeClass('hide');
    jQuery('.dark-btn').removeClass('active');
    jQuery('.container.dark-light').addClass('hide');
}
function activeDarkLight(){
    jQuery('.lang-btn').removeClass('active');
    jQuery('.container.lang').addClass('hide');
    jQuery('.dark-btn').addClass('active');
    jQuery('.container.dark-light').removeClass('hide');
}

function closeSubmenu(){
    jQuery(".header-menu ul li.submenu").removeClass("open");
}
// FAQs
function toggleFaq(element) {
    var current_faq_card = jQuery(element).parent();
    var content_block = current_faq_card.parent();
    var faq_cards = content_block[0].children;

    for (var i = 0; i < faq_cards.length; i++) {
        if (faq_cards[i] == current_faq_card[0]) {
            current_faq_card.toggleClass('open');
            current_faq_card.toggleClass('close');
        }
        else {
            jQuery(faq_cards[i]).removeClass('open');
            jQuery(faq_cards[i]).addClass('close');
        }
    }
}


// Mega Menu
function toggleMegaMenuOnClick() {
    jQuery('section.mega-menu').toggleClass('closed');
}
// Language Switcher

function toggleLanguageSwitcher() {
    jQuery('header .language .icon').toggleClass('active');
    jQuery('header li.current-item').removeClass('open');
    jQuery('header .language-menu').toggleClass('closed');
    jQuery('.mega-menu').addClass('closed'); 
}


function openSubmenu(element) {
    jQuery(element).parent().parent().toggleClass('opened');

    const megaMenu = jQuery('section.mega-menu');
    megaMenu.find('.menu-header .close-icon').addClass('hide');
    megaMenu.find('.menu-header .close-submenu-icon').removeClass('hide');
}

function closeSubmenuOnClick() {
    const megaMenu = jQuery('section.mega-menu');

    megaMenu.find('.menu-header .close-icon').removeClass('hide');
    megaMenu.find('.menu-header .close-submenu-icon').addClass('hide');

    megaMenu.find('.menu ul li.opened').removeClass('opened');
}

function selectCompetitionOnClick(element) {
    const competition = jQuery(element);

    if (competition.hasClass('active')) return;

    const competitionId = competition.attr('data-competition-id');

    const competitionWrapperItems = jQuery('.competitions.wrapper .item');
    competitionWrapperItems.each(function () {
        if (jQuery(this).attr('data-competition-id') == competitionId) jQuery(this).addClass('active');
        else jQuery(this).removeClass('active');
    });

    const teamsWrappers = jQuery('.teams.wrapper');
    teamsWrappers.each(function () {
        if (jQuery(this).attr('data-competition-id') == competitionId) jQuery(this).removeClass('hide');
        else jQuery(this).addClass('hide');
    });
}

/* Correio Braziliense
    function megaMenuEscape() {
        jQuery(document).click(event => {
            const divToEscape = jQuery('section.mega-menu');

            const divToIgnoreIfClicked = jQuery('.action-mega-menu.toggle');

            if(divToEscape.length > 0) {
                if((!divToEscape.is(event.target) && divToEscape.has(event.target).length == 0) && !divToIgnoreIfClicked.is(event.target) && divToIgnoreIfClicked.has(event.target).length == 0) {
                    divToEscape.addClass('closed');

                    //jQuery('body').removeClass('mega-menu-open');
                }
            }
        })
    }
*/


// Show More
function actionShowMore(element) {
    jQuery(element).parent().find('.cards > .responsiveness:lt(5)').removeClass('responsiveness');
    jQuery(element).parent().find('.cards > .hide:lt(5)').removeClass('hide');
    
    jQuery('.sportsbooks .cards > .card').length;

    var countz = 0;
    
    $('.sportsbooks .cards').find('.card').each(function(){
        if($(this).hasClass("hide"))
            countz++;
    });
    if(countz == 0){
        jQuery('.sportsbooks .show-more').addClass('responsiveness'); jQuery('.sportsbooks .show-less').toggleClass('responsiveness');
    }

}
// Show Less
function actionShowLess(element) {
    jQuery(element).parent().find('.cards > .card').addClass('hide');
    jQuery(element).parent().find('.cards > .card:lt(5)').removeClass('hide');
    jQuery('.sportsbooks .show-more').toggleClass('responsiveness');
    jQuery('.sportsbooks .show-less').toggleClass('responsiveness');
}


// Show More Less Hero Content
function actionShowMoreLessContent(element) {
    var children = jQuery(element).parent().children();

    for (var i = 0; i < children.length; i++) jQuery(children[i]).toggleClass('hide');
}


// Content Navigation Action
function actionActiveContentNavigationItem(element) {
    jQuery(element).parent().find('li').removeClass('active');

    jQuery(element).toggleClass('active');
}

let currentHeadingIndex = 0;
function trackContentScroll() {
    if (jQuery('.widget-content-navigation').length > 0) {
        let headingsHeightArray = [];

        const contentBlockHeadings = jQuery('.content h2');
        contentBlockHeadings.each(function () {
            headingsHeightArray.push(jQuery(this).offset().top - 800);
        });
        
        jQuery(window).scroll(function (e) {
            
            if (!(jQuery(this).is(':animated'))) {
                const height = jQuery(window).scrollTop();
                
                for (let i = 0; i < headingsHeightArray.length; i++) {
                    
                    if (height > headingsHeightArray[i]) {
                        
                        //if (i != currentHeadingIndex) {
                            jQuery('.widget-content-navigation ul li').each(function () { if (jQuery(this).hasClass('active')) jQuery(this).removeClass('active') })
                            jQuery('.widget-content-navigation ul li').eq(i).addClass('active');
                        //}

                        currentHeadingIndex = i;
                    }
                }
            }
        });
    }
}

function addSidebarContentNavigationHeight(extraPadding = 45) {
    if (window.innerWidth < 1200) return;

    const viewportHeight = window.innerHeight;

    const widgetBanner = jQuery('.fixed-bottom-area .widget-banner')[0];
    let widgetBannerHeight = widgetBanner ? widgetBanner.offsetHeight : 0;

    const header = jQuery('header')[0];
    let headerHeight = header ? header.offsetHeight : 0;

    let sidebarHeight = viewportHeight - widgetBannerHeight - headerHeight - extraPadding;

    const sidebarContentNavigationDiv = jQuery('.col-xl-3 .sidebar')[0];
    if (sidebarContentNavigationDiv) sidebarContentNavigationDiv.style.height = `${sidebarHeight}px`;
}

function adjustSidebarContentNavigationHeight(extraPadding = 45) {
    if (window.innerWidth < 1200) return;

    const viewportHeight = window.innerHeight;

    const header = jQuery('header')[0];
    let headerHeight = header ? header.offsetHeight : 0;

    let sidebarHeight = viewportHeight - headerHeight - extraPadding;

    const sidebarContentNavigationDiv = jQuery('.col-xl-3 .sidebar')[0];
    if (sidebarContentNavigationDiv) sidebarContentNavigationDiv.style.height = `${sidebarHeight}px`;
}


// Auxiliar Functions
function leftPad(num, size) {
    num = num.toString();
    while (num.length < size) num = '0' + num;

    return num;
}


// Style
function setCowntdown() {
    setInterval(function () {
        jQuery('.countdown').each(function () {
            var seconds = jQuery(this).find('.seconds > span .value');
            if (seconds[0].innerHTML == 0) {
                seconds[0].innerHTML = 59;

                var minutes = jQuery(this).find('.minutes > span .value');
                if (minutes[0].innerHTML == 0) {
                    minutes[0].innerHTML = 59;

                    var hours = jQuery(this).find('.hours > span .value');
                    if (hours[0].innerHTML == 0) {
                        hours[0].innerHTML = 23;

                        var days = jQuery(this).find('.days > span .value');
                        days[0].innerHTML = leftPad(days[0].innerHTML - 1, 2);
                    }
                    else hours[0].innerHTML = leftPad(hours[0].innerHTML - 1, 2);
                }
                else minutes[0].innerHTML = leftPad(minutes[0].innerHTML - 1, 2);
            }
            else seconds[0].innerHTML = leftPad(seconds[0].innerHTML - 1, 2);
        });
    }, 1000);
}

function smoothHref() {
    jQuery('[href*="#"]').click(function (e) {
        e.preventDefault();

        var url = this.href;
        var url_array = url.split('#');

        if (url_array[1] != '') {
            var fixed_header_height = jQuery('header')[0].offsetHeight;

            jQuery('html, body').animate({
                scrollTop: jQuery(jQuery('#' + url_array[url_array.length - 1]).offset().top)[0] - fixed_header_height - 5
            }, 500);
        }
    });
}

// Advertiser Geographical Card Reviews
function trackSportsbookCardScroll() {
    const card = jQuery('.after-footer > .container > .card > .advertiser-geographical-area');
    if (card.length > 0) {
        var heroCardHeight = jQuery('.advertiser-geographical-area.card').eq(0).offset().top;
        var footerHeight = jQuery('footer').eq(0).offset().top;

        jQuery(window).resize(function () {
            heroCardHeight = jQuery('.advertiser-geographical-area.card').eq(0).offset().top;
            footerHeight = jQuery('footer').eq(0).offset().top;
        });

        jQuery(window).scroll(function () {
            const height = jQuery(window).scrollTop();
            const viewportBottom = height + jQuery(window).height();

            if (height > heroCardHeight) card.removeClass('hide');
            else card.addClass('hide');

            if (viewportBottom > footerHeight) card.addClass('hide');
            else card.remove('hide');
        });
    }
}

function actionCardClose(element) {
    jQuery(element).parent().parent().remove();
}

// Layout
function layoutElement(tag, css_class, parent) {
    var element = document.createElement(tag);

    if (css_class !== null) element.className = css_class;

    parent.appendChild(element);

    return element;
}

function layoutImage(img_array, css_class, parent) {
    if (img_array === null) return;

    var img = document.createElement('img');

    if (css_class !== null) img.className = css_class;
    img.src = img_array['url'];
    img.alt = img_array['alt'];

    parent.appendChild(img);

    return img;
}

function layoutHeading(heading, title, css_class, parent) {
    if (title === null) return;

    var heading = document.createElement(heading);

    heading.innerHTML = title;
    if (css_class !== null) heading.className = css_class;

    parent.appendChild(heading);

    return heading;
}
function layoutContent(title, parent) {
    if (title === null) return;

    if(parent){
        
        var heading = document.createElement('span');
        
        heading.innerHTML = title;
        parent.appendChild(heading);
        //console.log(heading);
        return heading;
    }
}

function layoutTitle(heading, title, icon, css_class, parent) {
    if (title === null && icon !== null) return layoutImage(icon, css_class, parent);
    if (title !== null && icon === null) return layoutHeading(heading, title, css_class, parent);
    if (title === null && icon === null) return;

    var div = document.createElement('div');

    if (css_class !== null) div.className = css_class;

    layoutHeading(heading, title, '', div);
    layoutImage(icon, '', div);

    parent.appendChild(div);

    return div;

}

function layoutButton(link, heading, title, icon, css_class, parent, target = null, rel = null,excerpt , excerptDiv) {
    
    if (link === null) return layoutTitle(heading, title, icon, css_class, parent);

    var a = document.createElement('a');

    if (css_class !== null) a.className = css_class;
    a.href = link['url'];
    a.title = link['title'];
    if (target !== null) a.target = target;
    if (rel !== null) a.rel = rel;
    
    if (title !== null) layoutHeading(heading, title, '', a);
    if (excerpt !== null) layoutContent(excerpt, excerptDiv);

    if (icon !== null) layoutImage(icon, '', a);

    parent.appendChild(a);

    return a;
}

function layoutScript(url, parent) {
    var script = document.createElement('script');
    script.src = url;

    parent.appendChild(script);
}

// function layoutAdvertiserGeographicalAreaButton(link, heading, title, icon, css_class, parent, target = null, rel = null, placement = null, link_type = null, section = null, rank = null, advertiser_geographical_area_identifier = null, marketing_source_identifier = null) {
//     if(link === null) return layoutTitle(heading, title, icon, css_class, parent);

//     var a = document.createElement('a');
//     a.className = 'os-ms';

//     if(css_class !== null) a.addClass(css_class);
//     a.href = link['url'];
//     a.title = link['title'];
//     if(target !== null) a.target = target;
//     if(rel !== null) a.rel = rel;
//     a.setAttribute("data-os_aga", link['title']);
//     if(placement !== null) a.setAttribute("data-os_dlp", placement);
//     if(link_type !== null) a.setAttribute("data-os_dlt", link_type);
//     if(section !== null) a.setAttribute("data-os_element", section);
//     if(advertiser_geographical_area_identifier !== null) a.setAttribute("data-os_adv_id", advertiser_geographical_area_identifier);
//     if(rank !== null) a.setAttribute("data-os_r", rank);
//     if(marketing_source_identifier !== null) a.setAttribute("data-os_ms", marketing_source_identifier);

//     if(title !== null) layoutHeading(heading, title, '', a);

//     if(icon !== null) layoutImage(icon, '', a);

//     parent.appendChild(a);

//     return a;
// }


// Cookies
function setCookie(cname, cvalue, seconds) {
    if (seconds) {
        var d = new Date();
        d.setTime(d.getTime() + (seconds * 1000));
        var expires = 'expires=' + d.toUTCString();

        document.cookie = cname + '=' + cvalue + ';' + expires + ';path=/';
    }
    else document.cookie = cname + '=' + cvalue + ';path=/';
}

function getCookie(cname) {
    var name = cname + '=';
    var ca = document.cookie.split(';');

    for (var i = 0; i < ca.length; i++) {
        var c = ca[i];

        while (c.charAt(0) == ' ') c = c.substring(1);
        if (c.indexOf(name) == 0) return c.substring(name.length, c.length);
    }

    return '';
}

function checkCookie(new_identifier, time) {
    var identifier = getCookie(new_identifier);

    if (identifier != '') return false;
    else if (new_identifier != '' && new_identifier != null) {
        setCookie(new_identifier, new_identifier, time);

        return true;
    }
}

// Drop Cookie
function dropCookie() {
    const url = `${ajaxChildThemeUrlPrefix}drop-cookie.php`;

    jQuery.ajax({
        url: url,
        data: {
            wp_site_id: wp_site_id,
            wp_post_id: wp_post_id
        },
        success: function (data) {
            data.advertisers_geographical_areas.forEach(advertiserGeographicalArea => {
                const bodyDiv = jQuery(document.body)[0];

                const iframe = layoutElement('iframe', null, bodyDiv);
                iframe.src = advertiserGeographicalArea.donation_links.cookie_drop.url;
                iframe.style.display = 'none';
                jQuery(iframe).addClass('os-ms');
                iframe.setAttribute("data-os_element", 'Main');
                if (advertiserGeographicalArea.identifier !== null) iframe.setAttribute("data-os_adv_id", advertiserGeographicalArea.identifier);
                if (advertiserGeographicalArea.marketing_source_identifier !== null) iframe.setAttribute("data-os_ms", advertiserGeographicalArea.marketing_source_identifier);
            })
        },
        dataType: 'json'
    });
}

// Iframe 100%
function fit() {
    var iframes = document.querySelectorAll("iframe.gh-fit")
    
    for(var id = 0; id < iframes.length; id++) {
        var win = iframes[id].contentWindow
        var doc = win.document
        var html = doc.documentElement
        var body = doc.body
        var ifrm = iframes[id] // or win.frameElement

        if(body) {
            body.style.overflowX = "scroll" // scrollbar-jitter fix
            body.style.overflowY = "hidden"
        }
        if(html) {
            html.style.overflowX = "scroll" // scrollbar-jitter fix
            html.style.overflowY = "hidden"
            var style = win.getComputedStyle(html)
            ifrm.width = parseInt(style.getPropertyValue("width")) // round value
            ifrm.height = parseInt(style.getPropertyValue("height"))
        } 
    }

    requestAnimationFrame(fit)
}

addEventListener("load", requestAnimationFrame.bind(this, fit))

// Banner Manager
/*function bannerManager() {
    const widgetAreas = jQuery('.banner-manager');

    widgetAreas.each(function () {
        const bannerManagerContainer = jQuery(this);
        const dataId = bannerManagerContainer.attr('data-id');

        if(!(dataId)) return;

        const url = `${ajaxChildThemeUrlPrefix}banner-manager.php`;
    
        jQuery.ajax({
            url: url,
            data: {
                data_id: dataId,
                wp_site_id: wp_site_id,
                wp_post_id: wp_post_id
            },
            success: function (bannerObject) {
                if(bannerObject['has_cookies']) if(getCookie('banner_close_' + dataId) != '') return;

                if(bannerObject['banner']) {
                    if(bannerObject['banner']['style']) {
                        const bannerContainer = layoutElement('div', 'banner', bannerManagerContainer[0]);
                        bannerContainer.setAttribute("data-os_element", 'Footer');
                        if(bannerObject['banner']['advertiser_geographical_area']['identifier'] !== null) bannerContainer.setAttribute("data-os_adv_id", bannerObject['banner']['advertiser_geographical_area']['identifier']);
                        if(bannerObject['banner']['advertiser_geographical_area']['marketing_source_identifier'] !== null) bannerContainer.setAttribute("data-os_ms", bannerObject['banner']['advertiser_geographical_area']['marketing_source_identifier']);

                        if(bannerObject['has_close']) {
                            const closeDiv = layoutElement('div', 'close', bannerContainer);
                            if(bannerObject['has_cookies']) jQuery(closeDiv).attr('data-id', dataId)
                            jQuery(closeDiv).click(function(e) { handleCloseBannerOnClick(e.target, bannerObject['has_cookies'] ? true : false) })
                            layoutImage(bannerObject['fields']['close_icon'], null, closeDiv);
                        }

                        for(const [key, style] of Object.entries(bannerObject['banner']['style'])) {
                            const bannerSizeElement = layoutElement('div', 'banner-size ' + key, bannerContainer);
                            layoutAdvertiserGeographicalAreaButton(bannerObject['banner']['advertiser_geographical_area']['donation_links']['widget'], null, null, style, null, bannerSizeElement, '_blank', 'nofollow',  (bannerObject['banner']['placement']['name'] !== null ? bannerObject['banner']['placement']['name'] : 'Widget'), 'Image');
                        }

                        if(bannerObject['has_cookies']) setCookie('banner_index_' + dataId, bannerObject['banner_index']);

                        return;
                    }
                };
            },
            dataType: 'json'
        });
    });
}*/

function handleCloseBannerOnClick(element, has_cookies = false) {
    const currentElement = jQuery(element);

    const closeElement = currentElement.closest('.close');
    const bannerElement = currentElement.closest('.banner');

    if (has_cookies) setCookie('banner_close_' + closeElement.attr('data-id'), '1');

    if (window.adjustSidebarContentNavigationHeight) adjustSidebarContentNavigationHeight();

    bannerElement.remove();
}


// Pagination General
function getPaginationTotalPages(entriesPerPage, totalEntries) {
    if (!entriesPerPage || !totalEntries) return 1;

    return Math.ceil(totalEntries / entriesPerPage);
}

function handlePaginationStyle(paginationDiv, currentPage, totalPages, icon = null, navigationCallback = null, pageCallback = null, template = null) {
    let navigationFirstIconDiv = paginationDiv.find('.navigation.first');
    let navigationLastIconDiv = paginationDiv.find('.navigation.last');

    let navigationLeftIconDiv = paginationDiv.find('.navigation.left');
    if (navigationLeftIconDiv.length == 0) {
        navigationLeftIconDiv = layoutElement('div', 'navigation left', paginationDiv[0]);
        navigationLeftIconDiv.addEventListener('click', event => window[navigationCallback](event.currentTarget, -1, template));
        layoutImage(icon, null, navigationLeftIconDiv);

        navigationLeftIconDiv = jQuery(navigationLeftIconDiv);
    }
    else navigationLeftIconDiv.toggleClass('hide');

    if (currentPage != 1) {
        navigationLeftIconDiv.removeClass('hide');
        navigationFirstIconDiv.removeClass('hide');
    }
    else {
        navigationLeftIconDiv.addClass('hide');
        navigationFirstIconDiv.addClass('hide');
    }

    let pagesDiv = paginationDiv.find('.pages');
    if (pagesDiv.length == 0) pagesDiv = jQuery(layoutElement('div', 'pages', paginationDiv[0]));
    pagesDiv.children().each((index, el) => jQuery(el).remove());

    let pageNumberDiv = null;
    let pageDotsDiv = null;

    if (currentPage != 1) {
        pageNumberDiv = layoutElement('div', 'page number', pagesDiv[0]);
        pageNumberDiv.addEventListener('click', (event) => window[pageCallback](event.currentTarget, 1, template));
        layoutTitle('span', 1, null, null, pageNumberDiv);
    }

    if (currentPage > 4) {
        pageDotsDiv = layoutElement('div', 'page dots', pagesDiv[0]);
        layoutHeading('span', '...', null, pageDotsDiv);
    }

    for (let i = currentPage - 2; i <= currentPage + 2; i++) {
        if (i == currentPage) {
            pageNumberDiv = layoutElement('div', 'page number current', pagesDiv[0]);
            layoutHeading('span', i, null, pageNumberDiv);
        } else if (i > 1 && i < totalPages) {
            pageNumberDiv = layoutElement('div', 'page number', pagesDiv[0]);
            pageNumberDiv.addEventListener('click', (event) => window[pageCallback](event.currentTarget, i, template));
            layoutHeading('span', i, null, pageNumberDiv);
        }
    }

    if (currentPage < totalPages - 3) {
        pageDotsDiv = layoutElement('div', 'page dots', pagesDiv[0]);
        layoutHeading('span', '...', null, pageDotsDiv);
    }

    if (currentPage != totalPages) {
        pageNumberDiv = layoutElement('div', 'page number', pagesDiv[0]);
        pageNumberDiv.addEventListener('click', (event) => window[pageCallback](event.currentTarget, totalPages, template));
        layoutHeading('span', totalPages, null, pageNumberDiv);
    }

    let navigationRightIconDiv = paginationDiv.find('.navigation.right');
    if (navigationRightIconDiv.length == 0) {
        navigationRightIconDiv = layoutElement('div', 'navigation right', paginationDiv[0]);
        navigationRightIconDiv.addEventListener('click', event => window[navigationCallback](event.currentTarget, 1, template));

        layoutImage(icon, null, navigationRightIconDiv);

        navigationRightIconDiv = jQuery(navigationRightIconDiv);
    }

    if (currentPage != totalPages) {
        navigationRightIconDiv.removeClass('hide');
        navigationLastIconDiv.removeClass('hide');
    }
    else {
        navigationRightIconDiv.addClass('hide');
        navigationLastIconDiv.addClass('hide');
    }
}

function actionPaginationNavigation(element, action, template = null) {
    // Limit conditions
    pagination_current_filter['pagination']['page'] += action;

    if (template == 'search-archive') requestSearchArchivePaginationEntries();
    else if (template == 'betting-tips-archive') requestBettingTipsPaginationEntries();
    else if (template == 'betting-tips-sport-archive') requestBettingTipsPaginationEntries();
    else requestPaginationEntries();
}

function handlePaginationPageSelect(element, page, template = null) {
    if (jQuery(element).hasClass('current')) return;

    pagination_current_filter['pagination']['page'] = page;

    if (template == 'search-archive') requestSearchArchivePaginationEntries();
    else if (template == 'betting-tips-archive') requestBettingTipsPaginationEntries();
    else if (template == 'betting-tips-sport-archive') requestBettingTipsPaginationEntries();
    else requestPaginationEntries();
}

function requestPaginationEntries() {
    const url = `${ajaxMainThemeUrlPrefix}pagination.php`;

    jQuery.ajax({
        url: url,
        data: {
            wp_site_id: wp_site_id,
            wp_post_id: wp_post_id,
            pagination_filter: pagination_current_filter
        },
        success: function (data) {
            pagination_current_filter.pagination.total_entries = data.total_entries;

            handlePaginationEntries(data.entries);

            const paginationDiv = jQuery('section.main .pagination');

            handlePaginationStyle(paginationDiv, pagination_current_filter.pagination.page, getPaginationTotalPages(pagination_current_filter.pagination.entries_per_page, pagination_current_filter.pagination.total_entries), data.pagination_icon, 'actionPaginationNavigation', 'handlePaginationPageSelect');
        },
        dataType: 'json'
    });
}

function handlePaginationEntries(wpPosts) {
    const cardsDiv = jQuery('section.main .cards');
    cardsDiv.children().each((index, el) => jQuery(el).remove());
    
    wpPosts.forEach(wpPost => createWpPostVerticalMediumCard(wpPost, cardsDiv[0]));
}


// Pagination Betting Tips
function handleBettingTipsPaginationEntries(paginationDiv, data) {
    const cardsDiv = jQuery('section.main .cards');
    cardsDiv.children().each((index, el) => jQuery(el).remove());
    
    if (data.entries) {
        let startIndex = (pagination_current_filter.pagination.page - 1) * pagination_current_filter['pagination']['entries_per_page'];
        const endIndex = (pagination_current_filter.pagination.page * pagination_current_filter['pagination']['entries_per_page']) - 1;
        var number = 0;
        while (data.entries[startIndex] && startIndex <= endIndex) {
                            
            if(number == 0){
                createWpPostVerticalMediumCard(data.entries[startIndex], cardsDiv[0]);
            }else if(number > 0 && number < 5 ){
                createWpPostVerticalMediumCard(data.entries[startIndex], cardsDiv[1]);
            }else if(number > 4 && number < 7 ){
                createWpPostVerticalMediumCard(data.entries[startIndex], cardsDiv[2]);
            }else{
                createWpPostVerticalMediumCard(data.entries[startIndex], cardsDiv[3]);
            }

            startIndex++;
            number ++;
        }

        handlePaginationStyle(paginationDiv, pagination_current_filter.pagination.page, getPaginationTotalPages(pagination_current_filter.pagination.entries_per_page, pagination_current_filter.pagination.total_entries), pagination.data.icon, 'actionPaginationNavigation', 'handlePaginationPageSelect', 'betting-tips-archive');
    }
}

function requestBettingTipsPaginationEntries() {
    const paginationDiv = jQuery('section.main .pagination');

    if (!pagination.data) {
        pagination.fetchingData = true;

        const url = `${ajaxMainThemeUrlPrefix}betting-tips-pagination.php`;

        jQuery.ajax({
            url: url,
            data: {
                wp_site_id: wp_site_id,
                wp_post_id: wp_post_id,
                pagination_filter: pagination_current_filter
            },
            success: function (data) {
                if (!data.entries) return;
                
                pagination.data = {};
                pagination.data.entries = data.entries.filter(wpPost => (pagination_current_filter.filter.relationships ? pagination_current_filter.filter.relationships.includes(wpPost.parent) : true) && pagination_current_filter.filter.cpt == wpPost.type && pagination_current_filter.filter.template == wpPost.template);
                pagination.data.icon = data.pagination.icon;

                pagination_current_filter.pagination.total_entries = pagination.data.entries.length;

                handleBettingTipsPaginationEntries(paginationDiv, pagination.data);

                handlePaginationStyle(paginationDiv, pagination_current_filter.pagination.page, getPaginationTotalPages(pagination_current_filter.pagination.entries_per_page, pagination_current_filter.pagination.total_entries), pagination.data.icon, 'actionPaginationNavigation', 'handlePaginationPageSelect', 'betting-tips-archive');

                pagination.fetchingData = false;
            },
            dataType: 'json'
        });
    }
    else {
        handleBettingTipsPaginationEntries(paginationDiv, pagination.data);

        handlePaginationStyle(paginationDiv, pagination_current_filter.pagination.page, getPaginationTotalPages(pagination_current_filter.pagination.entries_per_page, pagination_current_filter.pagination.total_entries), pagination.data.icon, 'actionPaginationNavigation', 'handlePaginationPageSelect', 'betting-tips-archive');
    }
}


// Pagination Search
function handleSearchArchivePaginationEntries(paginationDiv, data) {
    const cardsDiv = jQuery('.results > .cards');
    cardsDiv.children().each((index, el) => jQuery(el).remove());
    
    if (data.entries) {
        let startIndex = (pagination_current_filter.pagination.page - 1) * pagination_current_filter['pagination']['entries_per_page'];
        const endIndex = (pagination_current_filter.pagination.page * pagination_current_filter['pagination']['entries_per_page']) - 1;

        while (data.entries[startIndex] && startIndex <= endIndex) {
            createWpPostVerticalMediumSearchCard(data.entries[startIndex], cardsDiv[0]);

            startIndex++;
        }

        handlePaginationStyle(paginationDiv, pagination_current_filter.pagination.page, getPaginationTotalPages(pagination_current_filter.pagination.entries_per_page, pagination_current_filter.pagination.total_entries), pagination.data.icon, 'actionPaginationNavigation', 'handlePaginationPageSelect', 'search-archive');
    }
}

function requestSearchArchivePaginationEntries() {
    const paginationDiv = jQuery('.results .pagination');

    if (!pagination.data) {
        pagination.fetchingData = true;
        const url = `${ajaxChildThemeUrlPrefix}search-archive.php`;
        
        jQuery.ajax({
            url: url,
            data: {
                wp_site_id: wp_site_id,
                wp_post_id: wp_post_id,
                pagination_filter: pagination_current_filter
            },
            success: function (data) {
                if (!data.entries) return;
                pagination.data = {};
                pagination.data.entries = data.entries.filter(wpPost => wpPost.name.toLowerCase().includes(pagination_current_filter.filter.search_query.toLowerCase()));
                pagination.data.icon = data.pagination.icon;

                pagination_current_filter.pagination.total_entries = pagination.data.entries.length;

                handleSearchArchivePaginationEntries(paginationDiv, pagination.data);

                handlePaginationStyle(paginationDiv, pagination_current_filter.pagination.page, getPaginationTotalPages(pagination_current_filter.pagination.entries_per_page, pagination_current_filter.pagination.total_entries), pagination.data.icon, 'actionPaginationNavigation', 'handlePaginationPageSelect', 'search-archive');

                pagination.fetchingData = false;
            },
            dataType: 'json'
        });
    }
    else {
        handleSearchArchivePaginationEntries(paginationDiv, pagination.data);

        handlePaginationStyle(paginationDiv, pagination_current_filter.pagination.page, getPaginationTotalPages(pagination_current_filter.pagination.entries_per_page, pagination_current_filter.pagination.total_entries), pagination.data.icon, 'actionPaginationNavigation', 'handlePaginationPageSelect', 'search-archive');
    }
}


// Layout Wp Posts
function createWpPostVerticalMediumCard(wpPost, parent , index) {
    
      
    const wpPostDiv = layoutElement('div', 'wp-post vertical medium card', parent);
       
    layoutButton(wpPost.link, null, null, null, 'area-link', wpPostDiv);

    const wrapperDiv = layoutElement('div', 'wrapper', wpPostDiv);
    
    //if (wpPost.category) {
        //const tagDiv = layoutElement('div', 'tag', wrapperDiv);
        //layoutHeading('span', wpPost.category, null, tagDiv);
    //}
    
    if($(parent).hasClass('grid-one') || $(parent).hasClass('grid-two')){
        
        if (wpPost.featured_image) {
            const bottomDiv = layoutElement('div', 'left', wrapperDiv);
            const featuredImageDiv = layoutElement('div', 'featured-image', bottomDiv);
            featuredImageDiv.style.backgroundImage = `url(${wpPost.featured_image.url})`;
        }

        const rightDiv = layoutElement('div', 'right', wrapperDiv);
        var titleDiv = layoutElement('div', 'title', rightDiv);
        var excerptDiv = layoutElement('div', 'content', rightDiv);
        
        layoutButton(wpPost.link, 'span', wpPost.title, null, null, titleDiv, null , null , wpPost.excerpt , excerptDiv);

    }else{
        
        if (wpPost.featured_image) {
            const bottomDiv = layoutElement('div', 'bottom', wrapperDiv);
            const featuredImageDiv = layoutElement('div', 'featured-image', bottomDiv);
            featuredImageDiv.style.backgroundImage = `url(${wpPost.featured_image.url})`;
        }
        
        var titleDiv = layoutElement('div', 'title', wrapperDiv);    
        layoutButton(wpPost.link, 'span', wpPost.title, null, null, titleDiv, null , null ,null, null);
    }

}

function createWpPostVerticalMediumSearchCard(wpPost, parentDiv) {
    const wpPostDiv = layoutElement('div', 'wp-post vertical medium search card', parentDiv);
    
    layoutButton(wpPost.link, null, null, null, 'area-link', wpPostDiv);

    const wrapperDiv = layoutElement('div', 'wrapper', wpPostDiv);
    
    //console.log(wpPost);

    const bottomDiv = layoutElement('div', 'bottom', wrapperDiv);
    const featuredImageDiv = layoutElement('div', 'featured-image', bottomDiv);
    if (wpPost.featured_image) {
        featuredImageDiv.style.backgroundImage = `url(${wpPost.featured_image.url})`;
    }else{
        featuredImageDiv.style.backgroundImage = `url(${wpPost.default_featured_image.url})`;
    }
    const titleDiv = layoutElement('div', 'title', wrapperDiv);

    if (wpPost.author_name) {
        const tagDiv = layoutElement('div', 'author', wrapperDiv);
        const timeDiv = layoutElement('div', 'time', tagDiv);
        var dateFormat = wpPost.published_date;
        //console.log(date("F j, Y, g:i a"));
        layoutHeading('div', wpPost.author_name.display_name, 'name-time', timeDiv);
        layoutHeading('div', wpPost.date_published, 'date', tagDiv);
    }
    layoutButton(wpPost.link, 'span', wpPost.title, null, null, titleDiv);
}



// Search Feature
function searchBarIconOnClick(event, filterInJs) {
    
    const searchBarDiv = jQuery('.search-bar.archive');
    
    const searchQuery = searchBarGetSearchQuery(searchBarDiv);
    
    if(searchQuery.length >= 3) searchBarRedirect(searchBarDiv, searchQuery);
    else return;
}
function openSearchBarOnClick(element) {
    const searchBar = jQuery(element).parent().find('.search-bar');
    searchBar.toggleClass('closed');
}

function closeSearchBarOnClick(element) {
    const searchBar = jQuery(element).closest('.search-bar');
    searchBar.toggleClass('closed');
}

/* Correio Braziliense
function searchModalEscape() {
    jQuery(document).click(event => {
        const divToEscape = jQuery('section.search-modal');

        const divToIgnoreIfClicked = jQuery('.action-search.toggle, div.no-results > .button');

        if(divToEscape.length > 0) {
            if((!divToEscape.is(event.target) && divToEscape.has(event.target).length == 0) && !divToIgnoreIfClicked.is(event.target) && divToIgnoreIfClicked.has(event.target).length == 0) {
                divToEscape.addClass('close');
    
                const searchBarDiv = jQuery('.search-bar'); 
                searchBarCleanSearchQuery(searchBarDiv);

                //jQuery('body').removeClass('search-open');
            }
        }
    })
}
*/

function searchBarGetSearchQuery(element) {
    
    const inputDiv = jQuery(element).closest('.search-bar').find('input');
    return inputDiv[0].value.toLowerCase();
    
}

function getSearchQuery() {
    const urlParams = new URLSearchParams(window.location.search);

    let searchParam = urlParams.get('search');

    return searchParam ? searchParam : '';
}

function searchBarCleanSearchQuery(element) {
    const inputDiv = jQuery(element).closest('.search-bar').find('input');
    inputDiv[0].value = '';
}

function handleSearchSubmit(element) {
    const searchBarDiv = jQuery(element).closest('.search-bar');

    let searchQuery = searchBarGetSearchQuery(searchBarDiv);

    if (searchQuery.length >= 3) searchBarRedirect(searchBarDiv, searchQuery);
}

function handleSearchSubmitOnEnter(event, element) {
    const searchQuery = searchBarGetSearchQuery(element);
    //console.log($(searchQuery).val());
    const searchBars = jQuery('.search-bar');
    //console.log('click key');
     searchBars.each(function () {
        jQuery(this).find('input')[0].value = searchQuery;
     });
     //console.log(element); 

     if (event.key === 'Enter') {
         event.preventDefault();        
         handleSearchSubmit(element);
    }
}

function searchBarRedirect(searchBarDiv, searchQuery) {
    const archivePageUrl = searchBarDiv.find('[data-archive-page-url]')[0].dataset.archivePageUrl;
    
    window.location.href = `${archivePageUrl}?search=${searchQuery}`;
}
function searchBarRedirectIcon(searchBarDiv) {
    const archivePageUrl = $(searchBarDiv).attr('data-archive-page-url');
    //data-archive-page-url
    window.location.href = `${archivePageUrl}`;
}
function searchArchiveLayoutOnLoad() {
    const resultsWrapperDiv = jQuery('.results-wrapper')[0];
    
    if (!pagination.data) {
        
        pagination.fetchingData = true;

        const url = `${ajaxChildThemeUrlPrefix}search-archive.php`;
        
        jQuery.ajax({
            url: url,
            success: function (data) {
                
                if (!data.entries) {
                    cleanSearchArchiveLayout();
                    searchArchiveLayoutNoResultsStyles(resultsWrapperDiv);
                    return;
                };

                pagination.data = {};
                pagination.data.entries = data.entries.filter(wpPost => wpPost.name.toLowerCase().includes(pagination_current_filter.filter.search_query.toLowerCase()));
                pagination.data.icon = data.pagination.icon;

                pagination_current_filter.pagination.total_entries = pagination.data.entries.length;

                if (pagination.data.entries.length == 0) searchArchiveLayoutNoResultsStyles(resultsWrapperDiv);

                pagination.fetchingData = false;
            },
            dataType: 'json'
        });
    }
    else {
        
        pagination.data.entries = pagination.data.entries.filter(wpPost => wpPost.name.toLowerCase().includes(pagination_current_filter.filter.search_query.toLowerCase()));

        pagination_current_filter.pagination.total_entries = pagination.data.entries.length;
        
        if (pagination.data.entries.length == 0) searchArchiveLayoutNoResultsStyles(resultsWrapperDiv, pagination_default_filter.no_results_styles);
        else searchArchiveLayoutResultsStyles(resultsWrapperDiv, pagination_current_filter, pagination.data.entries, pagination_default_filter.results_styles, pagination.styles);
    }

}

function searchArchiveLayoutResultsStyles(parentDiv, paginationCurrentFilter, paginationDataEntries, resultsStyles, paginationStyles) {
    
    paginationCurrentPage = paginationCurrentFilter.pagination.page;
    paginationEntriesPerPage = paginationCurrentFilter.pagination.entries_per_page * 1;
    paginationTotalEntries = paginationCurrentFilter.pagination.total_entries * 1;
    
    const resultsDiv = layoutElement('div', 'results', parentDiv);
    const cardsDiv = layoutElement('div', 'cards grid-four', resultsDiv);
      
    const heroTitleDiv = jQuery('section.hero .title')[0];
    //layoutHeading(resultsStyles.labels_top_tag.heading, resultsStyles.labels_top_tag.title, null, heroTitleDiv);
    //searchArchiveLayoutSearchQuery();
    
    if (paginationDataEntries) {
        let startIndex = (paginationCurrentPage - 1) * paginationEntriesPerPage;
        const endIndex = (paginationCurrentPage * paginationEntriesPerPage) - 1;

        while (paginationDataEntries[startIndex] && startIndex <= endIndex) {
            createWpPostVerticalMediumSearchCard(paginationDataEntries[startIndex], cardsDiv);
            startIndex++;
        }

        if (paginationTotalEntries > paginationEntriesPerPage) searchArchiveLayoutResultsBottomStyles(resultsDiv, paginationEntriesPerPage, paginationTotalEntries, resultsStyles, paginationStyles);
    }
}

function searchArchiveLayoutNoResultsStyles(parentDiv, noResultsStyles) {
    const heroTitleDiv = jQuery('.no-results')[0];
    
    searchArchiveLayoutSearchQuery();
    
    layoutHeading(noResultsStyles.introduction_title.heading, noResultsStyles.introduction_title.title, null, heroTitleDiv);

}

function searchArchiveLayoutResultsBottomStyles(parentDiv, entriesPerPage, totalEntries, resultsStyles, paginationStyles) {
    const paginationDiv = layoutElement('div', 'pagination', parentDiv);

    const tagDiv = layoutElement('div', 'tag', paginationDiv);
    layoutHeading(resultsStyles.labels_bottom_tag.heading, resultsStyles.labels_bottom_tag.title, null, tagDiv);

    searchArchiveLayoutPaginationStyles(paginationDiv, entriesPerPage, totalEntries, paginationStyles);
}

function searchArchiveLayoutPaginationStyles(parentDiv, entriesPerPage, totalEntries, paginationStyles) {
    let paginationTotalPages = getPaginationTotalPages(entriesPerPage, totalEntries);

    paginationDiv = layoutElement('div', 'pagination', parentDiv);

    divNavigationFirst = layoutElement('div', `navigation first hide`, paginationDiv);
    divNavigationFirst.dataset.page = 1;
    divNavigationFirst.addEventListener('click', event => handlePaginationPageSelect(event.currentTarget, 1, 'search-archive'));
    layoutImage(paginationStyles['navigation_first_page_icon'], null, divNavigationFirst);

    divNavigationLeft = layoutElement('div', 'navigation left hide', paginationDiv);
    divNavigationLeft.dataset.navigation = -1;
    divNavigationLeft.addEventListener('click', event => actionPaginationNavigation(event.currentTarget, -1, 'search-archive'));
    layoutImage(paginationStyles['navigation_icon'], null, divNavigationLeft);


    divPages = layoutElement('div', 'pages', paginationDiv);

    divCurrentPageNumber = layoutElement('div', 'page number current', divPages);
    layoutHeading('span', 1, null, divCurrentPageNumber);

    for (let i = 2; i < 5; i++) {
        if (i > paginationTotalPages) break;
        divPageNumber = layoutElement('div', 'page number', divPages);
        divPageNumber.dataset.page = i;
        divPageNumber.addEventListener('click', event => handlePaginationPageSelect(event.currentTarget, i, 'search-archive'));
        layoutHeading('span', i, null, divPageNumber);
    }

    if (paginationTotalPages > 5) {
        divPageDots = layoutElement('div', 'page dots', divPages);
        layoutHeading('span', '...', null, divPageDots);


        divPageNumber = layoutElement('div', 'page number', divPages);
        divPageNumber.dataset.page = paginationTotalPages;
        divPageNumber.addEventListener('click', event => handlePaginationPageSelect(event.currentTarget, paginationTotalPages, 'search-archive'));
        layoutHeading('span', paginationTotalPages, null, divPageNumber);
    }

    if (paginationTotalPages > 1) {
        divNavigationRight = layoutElement('div', 'navigation right', paginationDiv);
        divNavigationRight.dataset.navigation = +1;
        divNavigationRight.addEventListener('click', event => actionPaginationNavigation(event.currentTarget, +1, 'search-archive'));
        layoutImage(paginationStyles['navigation_icon'], null, divNavigationRight);
    }

    if (paginationTotalPages > 2) {
        divNavigationLast = layoutElement('div', 'navigation last', paginationDiv);
        divNavigationLast.dataset.page = paginationTotalPages;
        divNavigationLast.addEventListener('click', event => handlePaginationPageSelect(event.currentTarget, paginationTotalPages, 'search-archive'));
        layoutImage(paginationStyles['navigation_last_page_icon'], null, divNavigationLast);
    }
}

function searchArchiveLayoutSearchQuery() {
    const searchQueryStringDiv = jQuery('.search-query-string');
    searchQueryStringDiv[0].innerHTML = getSearchQuery();
}

function cleanSearchArchiveLayout() {
    const resultsWrapperDiv = jQuery('.results-wrapper');    
    resultsWrapperDiv.empty();
}

// Search Bar not used and to be analysed
/*
function searchBarCleanUp(searchBarDiv) {
    const bottomDiv = searchBarDiv.find('> .bottom');

    bottomDiv.addClass('hide');

    searchBarCleanWpPosts(bottomDiv.find('.wp-posts'));

    bottomDiv.find('.pagination').remove();
}

function searchBarCleanWpPosts(wpPostsDiv) {
    wpPostsDiv.children().each((index, el) => jQuery(el).remove());
}
*/
function searchBarOnKeyUp(event, filterInJs) { 

    const searchBarDiv = jQuery(event.target).closest('.search-bar');
    
    const searchQuery = searchBarGetSearchQuery(searchBarDiv);
    
    pagination_current_filter['pagination']['page'] = 1;
    
    if(searchQuery.length > 3) {
        if(searchBarDiv.closest('section.results').length > 0) {
            pagination_current_filter['filter']['search_query'] = searchQuery;

            requestPaginationEntries(searchBarDiv[0]);
        }
    }
    
    if(event.code == 'Enter' && searchQuery.length >= 3) {
        searchBarRedirect(searchBarDiv, searchQuery);
        return;
    }
}
/*
function searchBarGetData() {
    searchBarFetchingData = true;

    const url = `${ajaxMainThemeUrlPrefix}search.php`;

    jQuery.ajax({
        url: url,
        data: {
        },
        success: function(data) {
            searchBar.data = data;

            searchBarFetchingData = false;
        },
        dataType: 'json'
    });
}

function searchBarHandleData(searchBarDiv, searchQuery) {
    searchQuery = searchBarGetSearchQuery(searchBarDiv.children(':first')[0]); // Hack to make sure searchquery is updated to the user input

    const bottomDiv = searchBarDiv.find('.bottom');
    bottomDiv.removeClass('hide');

    const wpPostsDiv = bottomDiv.find('.wp-posts');

    let createdWpPostDiv = false;

    searchBarCleanWpPosts(wpPostsDiv);

    if(searchBar.data.results) {
        let postsWithinSearchQuery = 0;

        const startIndex = (search_bar_pagination_current_filter.pagination.page - 1) * search_bar_pagination_current_filter['pagination']['entries_per_page'];
        const endIndex = search_bar_pagination_current_filter.pagination.page * search_bar_pagination_current_filter['pagination']['entries_per_page'];

        let counter = 0;

        while(searchBar.data.results[counter]) {
            if(searchBar.data.results[counter].title.toLowerCase().includes(searchQuery)) {
                postsWithinSearchQuery++;

                if(postsWithinSearchQuery > startIndex && postsWithinSearchQuery <= endIndex) {
                    createdWpPostDiv = true;

                    createWpPostVerticalSmallCard(searchBar.data.results[counter], wpPostsDiv[0]);
                }
            }

            counter++;
        }

        search_bar_pagination_current_filter['pagination']['total_entries'] = postsWithinSearchQuery;

        let paginationDiv = searchBarDiv.find('.pagination');
        if(paginationDiv.length == 0) paginationDiv = layoutElement('div', 'pagination', bottomDiv.find('> .container')[0]);

        handlePaginationStyle(jQuery(paginationDiv), search_bar_pagination_current_filter.pagination.page, getPaginationTotalPages(search_bar_pagination_current_filter.pagination.entries_per_page, search_bar_pagination_current_filter.pagination.total_entries), searchBar.data.pagination.icon, 'searchBarActionPaginationNavigation', 'searchBarHandlePaginationPageSelect', 'search-archive');
    }

    if(!searchBar.data.results || !createdWpPostDiv) {
        const noResults = layoutElement('div', 'no-results', wpPostsDiv[0]);
        layoutHeading('span', searchBar.data.no_results, null, noResults);
    }
}
*/



// Copy To Clipboard
function copyToClipboard(element, copyURL) {
    var currentElement = jQuery(element);
    if(currentElement.hasClass('information')){
        currentElement = jQuery(element).prev().find('.title');
        currentElement.parent().children().each(function () { jQuery(this).toggleClass('active'); });
    }else{
        currentElement.parent().children().each(function () { jQuery(this).toggleClass('active'); });
    }

    if (!copyURL) navigator.clipboard.writeText(window.location.href);
    else {
        navigator.clipboard.writeText(copyURL);

        setTimeout(() => {
            currentElement.parent().children().each(function () { jQuery(this).toggleClass('active'); });
        }, 2 * 1000);
    }
}

// Limits table
function showMoreLimitsTable(element) {
    
    jQuery(element).closest('table').removeClass('closed'); 
    
    console.log(jQuery(element).parent().parent().next());
    jQuery(element).parent().parent().next().removeClass('closed');
}
function showLessLimitsTable(element) {
    
     jQuery(element).closest('table').addClass('closed');
     jQuery(element).parent().parent().prev('table').addClass('closed');
}


// Forms

function formBirthDate(date) {
    if (date.day.length == 1) date.day = `0${date.day}`;
    if (date.month.length == 1) date.month = `0${date.month}`;

    const newDate = `${date.day}/${date.month}/${date.year}`;

    const fieldDiv = jQuery('.field.birth-date');

    fieldDiv[0].dataset.customFieldValue = newDate;

    fieldDiv.find('input')[0].value = newDate;
}

function formCustomSelectToggle(element) {
    const currentElement = jQuery(element);
    currentElement.closest('.field').toggleClass('open');
}

function formCustomSelectOption(element) {
    const currentElement = jQuery(element);
    if (currentElement.hasClass('current')) return;

    const fieldDiv = currentElement.closest('.field');
    fieldDiv[0].dataset.customFieldValue = jQuery(element).find('.option')[0].dataset.value;

    fieldDiv.find('.current').removeClass('current');

    const selectedDiv = fieldDiv.find('.selected');
    selectedDiv.find('.option').remove();

    selectedDiv.find('.option-wrapper').append(jQuery(element).find('.option').clone());

    currentElement.addClass('current');

    currentElement.closest('.field').toggleClass('open');
}

function formCustomSelectTelOption(element, telInputId) {
    const currentElement = jQuery(element);
    if (currentElement.hasClass('current')) return;

    const fieldDiv = currentElement.closest('.field');
    fieldDiv[0].dataset.customFieldValue = jQuery(element).find('.option')[0].dataset.value;

    fieldDiv.parent().find(`#${telInputId}`)[0].dataset.countryCode = jQuery(element).find('.option')[0].dataset.value;

    fieldDiv.find('.current').removeClass('current');

    const selectedDiv = fieldDiv.find('.selected');
    selectedDiv.find('.option').remove();

    selectedDiv.find('.option-wrapper').append(jQuery(element).find('.option').clone());

    currentElement.addClass('current');

    currentElement.closest('.field').toggleClass('open');
}

function formCustomMultiSelectOption(event) {
    const currentElement = jQuery(event.currentTarget);
    currentElement.toggleClass('current')

    if (!event.shiftKey) currentElement.closest('.options').find('.current').each((index, el) => el == event.currentTarget ? '' : jQuery(el).removeClass('current'));

    const fieldDiv = currentElement.closest('.field');

    let values = '';
    fieldDiv.find('.current').each((index, el) => values += index == 0 ? jQuery(el).find('.option')[0].dataset.value : (`,${jQuery(el).find('.option')[0].dataset.value}`));

    fieldDiv[0].dataset.customFieldValues = values;
}

function formClean(formDiv) {
    const errorFields = formDiv.find('.error');
    errorFields.each((index, field) => {
        const fieldErrors = jQuery(field).children();

        if (fieldErrors.length > 0) fieldErrors.each((index, error) => jQuery(error).remove());
    })

    const errorInput = formDiv.find('input.error');
    errorInput.each((index, field) => {
        jQuery(field).toggleClass('error');
    })

    const successDiv = formDiv.find('.success');
    if (successDiv.length > 0) {
        const successMessage = successDiv.children(':first');

        if (successMessage.length > 0) successMessage.remove();
    }
}

function formGetData(formFields, formIdentifier, formTypePostId) {
    const formData = new FormData();

    formData.append('wp_site_id', wp_site_id);
    formData.append('wp_post_id', wp_post_id);
    formData.append('form_identifier', formIdentifier);
    formData.append('form_type_post_id', formTypePostId);

    const fieldsData = {};

    formFields.each((index, field) => {
        const currentFieldDiv = jQuery(field);

        if (field.dataset.customFieldType == undefined) {
            const inputs = currentFieldDiv.find('textarea, input:not([type="checkbox"]), select'); // Checkbox has to be custom field
            if (inputs[0].name == 'password' || inputs[0].name == 'confirm-password' || inputs[0].name == 'current-password') inputs[0].type = 'password'; // Making sure that password and confirm password fields types are password and not text because of show/hide password

            fieldsData[inputs[0].name] = {
                name: inputs[0].name,
                type: inputs[0].type,
                full_validate: inputs[0].dataset.fullvalidate == 0 ? 0 : 1 // always 1 unless specified to be 0 
            }

            if (inputs[0].type == 'radio') {
                inputs.each((index, el) => {
                    if (el.checked) fieldsData[el.name].value = el.value;
                    else if (fieldsData[el.name].value == undefined) fieldsData[el.name].value = '';

                    if (el.required) fieldsData[el.name].required = el.required;
                    else if (fieldsData[el.name].required == undefined) fieldsData[el.name].required = false;
                })
            }
            else if (inputs[0].type == 'file') {
                formData.append(`attachment_${inputs[0].name}`, inputs[0].files[0]);

                fieldsData[inputs[0].name].value = inputs[0].files.length > 0 ? `attachment_${inputs[0].name}` : '';
                fieldsData[inputs[0].name].required = inputs[0].required;
                fieldsData[inputs[0].name].maximum_size = inputs[0].dataset.maximumSize ? Number(inputs[0].dataset.maximumSize) : '';
            }
            else if (inputs[0].type == 'select-multiple') {
                fieldsData[inputs[0].name].values = jQuery(inputs[0]).val();
                fieldsData[inputs[0].name].required = inputs[0].required;
            }
            else if (inputs[0].type == 'tel') {
                fieldsData[inputs[0].name].country_code = inputs[0].dataset.countryCode;
                fieldsData[inputs[0].name].value = inputs[0].value;
                fieldsData[inputs[0].name].required = inputs[0].required;
            }
            else {
                fieldsData[inputs[0].name].value = inputs[0].value;
                fieldsData[inputs[0].name].required = inputs[0].required;
            }
        }
        else {
            fieldsData[field.dataset.customFieldName] = {
                name: field.dataset.customFieldName,
                type: field.dataset.customFieldType,
                required: field.dataset.customFieldRequired == 1 ? true : false
            }

            if (field.dataset.customFieldType == 'checkbox') {
                fieldsData[field.dataset.customFieldName].values = [];

                jQuery(field).find(':checked').each((index, el) => fieldsData[field.dataset.customFieldName].values.push(el.value));
            }
            else if (field.dataset.customFieldType == 'select-one' || field.dataset.customFieldType == 'date') fieldsData[field.dataset.customFieldName].value = field.dataset.customFieldValue;
            else if (field.dataset.customFieldType == 'select-multiple') fieldsData[field.dataset.customFieldName].values = field.dataset.customFieldValues ? field.dataset.customFieldValues.split(',') : [];
        }
    })

    formData.append('fields', JSON.stringify(fieldsData));

    return formData;
}

function formErrors(errors, formFields) {
    for (const [key, values] of Object.entries(errors)) {
        formFields.each((index, field) => {
            if ((field.dataset.customFieldType == undefined && jQuery(field).find('textarea, input:not([type="checkbox"]), select')[0].name == key) || field.dataset.customFieldName == key) {
                const errorDiv = jQuery(field).find('.error:not(input)');
                values.forEach(message => layoutHeading('span', message, null, errorDiv[0]));

                jQuery(field).find('input').addClass('error');
            }
        })
    }
}

function formSuccess(formDiv, success) {

    if (success.action == 'redirect') location.replace(success.value);
    else if (success.action == 'success_message') formSuccessMessage(formDiv, success.value);
    else if (success.action == 'success_div') formSuccessDiv(formDiv, success.value);
    else if (success.action == 'none') return;
    //else location.reload();
    //formSuccessMessage(formDiv, success.value);
    $('#form-contact').addClass('sucess'); 
    $('.success-message').removeClass('hidden'); 
    
}

function formSuccessMessage(formDiv, successMessage) {
    const successDiv = formDiv.find('.success');
    if (successDiv.length > 0) layoutHeading('span', successMessage, null, successDiv[0]);
}

function formSuccessDiv(formDiv, successValue) {
    jQuery('.' + successValue.show).toggleClass('hide');
    jQuery('.' + successValue.hide).remove();
}

function formSubmit(formIdentifier, formTypePostId, element = null) {
    const formDiv = element ? jQuery(element).closest(`#form-${formIdentifier}`) : jQuery(`#form-${formIdentifier}`);

    const formFields = formDiv.find('.field:not(:has(input[type="button"]))');

    formClean(formDiv);

    const formData = formGetData(formFields, formIdentifier, formTypePostId); 

    const url = document.location.origin + '/pt-br/apostas/wp-content/themes/os-betting-child/ajax/forms.php';       

    jQuery.ajax({ 
        url: url,
        method: 'POST',
        data: formData,
        contentType: false,
        processData: false,
        success: function (data) {
            if (data.success) {
                formFields.find('input').val('');
                formSuccess(formDiv, data.success);

                if (formIdentifier == 'crmpopup') {
                    //handleCRMPopUpSubscribed(formDiv);
                }
            }
            else {
                formErrors(data.errors, formFields);
            }
        },
        dataType: 'json'
    });
}

// Copy Link Popup
function copyToClipboardAndPopup(element, copyURL) {
    const currentElement = jQuery(element);
    currentElement.parent().children().each(function () { jQuery(this).toggleClass('active'); });

    if (!copyURL) navigator.clipboard.writeText(window.location.href);
    else {
        navigator.clipboard.writeText(copyURL);

        setTimeout(() => {
            currentElement.parent().children().each(function () { jQuery(this).toggleClass('active'); });
        }, 2 * 1000);
    }

    // $('.social-sharing').removeClass('hidden');
     $('.snackbar').removeClass('closed');
    $('.snackbar .closeButton').on('click',function(){
        $('.snackbar').addClass('closed');
    });

    // $('.social-sharing').on('click',function(){
    //     $('.social-sharing').addClass('hidden');
    // });
    
    setTimeout(() => {
        $('.snackbar').addClass('closed');
        //$('.social-sharing').addClass('hidden');
    }, 2 * 2000);
    
}

// Pop Ups
// function closePopUp() {
//     // Pop Ups need to have an unique id and a class with the same name as the id
//     const bodyDiv = jQuery(document.body);

//     const popUpDiv = bodyDiv.find('.pop-up');
//     if (!popUpDiv.length) return;

//     const popUpId = popUpDiv[0].id;

//     popUpDiv.remove();

//     bodyDiv.removeClass(`pop-up ${popUpId}`);
// }

// function notRecommendedPopUpEscape() {
//     jQuery(document).click(event => {
//         const divToEscape = jQuery('.pop-up.not-recommended > .container');

//         const divToIgnoreIfClicked = jQuery('header');

//         if (divToEscape.length > 0) {
//             if ((!divToEscape.is(event.target) && divToEscape.has(event.target).length == 0) && (!divToIgnoreIfClicked.is(event.target) && divToIgnoreIfClicked.has(event.target).length == 0)) {
//                 divToEscape.parent().remove();

//                 jQuery(document.body).removeClass('pop-up');
//             }
//         }
//     })
// }


// SWIPER 
// init Swiper:
const swiper = new Swiper('.best-games .cards', {
    slidesPerView: 1.05,
    spaceBetween: 8,
    autoplay: {
        delay: 4000,
        disableOnInteraction: false,
    },
    //delay:'4000',
    loop: false,
    pauseOnMouseEnter: 'true',
    breakpoints: {
        999: {
            slidesPerView: 2,
            autoplay: true,
            spaceBetween: 32,
        }, 
        1200: {
            slidesPerView: 3,
            autoplay: false,
            spaceBetween: 32,
        }
    }
   
});

const swiper2 = new Swiper('.who-wins .cards', {
    slidesPerView: 1.05,
    spaceBetween: 8,
    autoplay: {
        delay: 4000,
        disableOnInteraction: false,
    },
    //delay:'4000',
    loop: false,
    pauseOnMouseEnter: 'true',
    breakpoints: {
        999: {
            slidesPerView: 2,
            autoplay: true,
            spaceBetween: 32,
        }, 
        1200: {
            slidesPerView: 3,
            autoplay: false,
            spaceBetween: 32,
        }
    }
   
});
